import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import getImageUrl from '../../utils/getImageUrl';

export class Image extends Component {

  // GIF 일 때 테스트 코드 필요 함.
  constructor() {
    super();
    this.state = {
      containerWidth: '100%',
      containerHeight: 'auto' 
    };

    this.calculateSize = this.calculateSize.bind(this);
  }

  componentDidMount() {
    this.calculateSize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.calculateSize);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.calculateSize)
    }
  }

  calculateSize() {
    const container = findDOMNode(this.refs.containers).parentNode;
    const containerRect = container.getBoundingClientRect();

    this.setState({
      containerWidth: containerRect.width,
      containerHeight: 'auto'
    });
  }

  render() {
    const { image, style, noFrame } = this.props;
    const { containerWidth, containerHeight } = this.state;

    const backgroundStyle = {
      width : containerWidth === 0 ? '100%' : containerWidth,
      height: containerHeight,
      backgroundColor: image.get('avg'),
      zIndex: -10
    };

    if (image.isGif()) {
      return (
        <div style={backgroundStyle} ref="containers">
          <img src={getImageUrl(image.get('url'))} className="img_thumb" style={style} alt="" />
          {
            !noFrame && <span className="frame_g" />
          }
          <span className="txt_gif">GIF</span>
        </div>
      )
    }

    return (
      <div style={backgroundStyle} ref="containers">
        <img src={getImageUrl(image.get('largeUrl') || image.get('url'))} className="img_thumb" style={style} alt="" />
        {
          !noFrame && <span className="frame_g" />
        }
      </div>
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/ImageHolder/index.js